import React, { ReactElement, ReactNode } from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

import { theme } from 'configs';
import { convertMinutesToStringFormat } from 'utils';

interface ValueLabelComponentProps {
  children: ReactElement;
  value: number;
  index: number;
  setScheduleUpdateDialogState: (props: { activeThumb: number; visible: boolean }) => void;
  deleteSchedule: (index: number) => void;
}

export const ValueLabelComponent = ({
  children,
  value,
  index,
  setScheduleUpdateDialogState,
  deleteSchedule,
}: ValueLabelComponentProps) => {
  return (
    <Tooltip
      enterTouchDelay={0}
      placement="top"
      title={
        <>
          {convertMinutesToStringFormat(value, true)}

          <ActionButton
            onClick={() => setScheduleUpdateDialogState({ activeThumb: index, visible: true })}
            icon={<Edit fontSize="small" />}
          />

          <ActionButton onClick={() => deleteSchedule(index)} icon={<Delete fontSize="small" />} />
        </>
      }
    >
      {children}
    </Tooltip>
  );
};

interface ActionButtonProps extends IconButtonProps {
  onClick: () => void;
  icon: ReactNode;
}

const ActionButton = ({ onClick, icon }: ActionButtonProps) => {
  return (
    <IconButton
      size="small"
      sx={{ color: theme.palette.primary.main, '&:hover': { color: theme.palette.primary.light } }}
      onClick={onClick}
      onMouseDown={(event) => event.stopPropagation()}
    >
      {icon}
    </IconButton>
  );
};
